import React from 'react'

const TEXT = 'DISEÑO WEB DE ALTO IMPACTO · WEBS EN 7 DÍAS · TRATO DIRECTO · CÓRDOBA & WORLDWIDE · CÓDIGO LIMPIO · SIN PLANTILLAS · '

export default function MarqueeStrip() {
  return (
    <div className="relative overflow-hidden bg-black border-y border-neutral-900 py-5">
      <div className="marquee-animate marquee-track select-none">
        {[...Array(4)].map((_, i) => (
          <span key={i}
            className="text-white/10 uppercase pr-0"
            style={{ fontFamily: 'Anton, sans-serif', fontSize: 'clamp(36px, 5vw, 72px)', letterSpacing: '0.02em', whiteSpace: 'nowrap' }}>
            {TEXT}
          </span>
        ))}
      </div>
    </div>
  )
}
